module.exports = __webpack_public_path__ + "static/media/pc_home_header.67093cd0.png";